module.exports = __webpack_public_path__ + "img/isis--a-journal-of-the-history-of-science-society-cover.beb27a2d.jpg";